// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"367":"b4dd79bf","852":"225e007b"}[chunkId] + ".css";
};